import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import Hero from "../../components/hero/hero";
import FunfactSecion from "../../components/FunfactSection/FunfactSection";
import JagmohanSinghSection from "../../components/JagmohanSinghSection/JagmohanSinghSection";
import About from "../../components/about/about";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import EarlyBirdBonuses from "../../components/EarlyBirdBonuses/EarlyBirdBonuses";
import WhySummitMattersSection from "../../components/WhySummitMattersSection/WhySummitMattersSection";
import WhatYouGetSection from "../../components/WhatYouGetSection/WhatYouGetSection";
// import SummitFeaturesSection from "../../components/SummitFeaturesSection/SummitFeaturesSection";
import TestimonialSection from "../../components/TestimonialSection/TestimonialSection";
import AudienceProfile from "../../components/AudienceProfile/AudienceProfile";
import MediaPartners from "../../components/MediaPartners/MediaPartners";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import CursorMaus from "../../components/CursorMaus/CursorMaus";
import Phone from "../../images/telephone.svg";
import Logo from "../../images/logo.webp";
const HomePage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>
          Jagmohan Singh Cash Flow Coach | Cash Flow Workshop India 2026
        </title>
        <meta
          name="description"
          content="Join Jagmohan Singh Cash Flow Coach at the Cash Flow Workshop India, and discover proven strategies to improve money mindset, manage cash flow, and create long-term financial growth."
        />
        <meta
          name="keywords"
          content="Jagmohan Singh Cash Flow Coach, Cash Flow Workshop India, Cash Flow Summit, Cash Flow Course for Business Owners, Jagmohan Singh Cash Flow Expert"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} telephone={Phone} hclass={"wpo-site-header s1"} />
      <Hero />
      <FunfactSecion hclass="funfact-section" />
      <EarlyBirdBonuses />
      <WhySummitMattersSection />
      <JagmohanSinghSection />
      <WhatYouGetSection />
      <About />
      <ServiceSection hclass={"services-section"} />
      {/* <SummitFeaturesSection hclass={"features-section"} /> */}
      <TestimonialSection />
      <AudienceProfile />
      <MediaPartners />
      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};
export default HomePage;
